import React, {useEffect} from 'react';
import { Route, Redirect, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from "../../context/auth";
import {urlRewriteUtil} from "../Wrapper/common.wrapper";

const PreAuthRouteWithLayout = props => {

    const history = useHistory();
    const location = useLocation();
    const { layout: Layout, component: Component, no_redirect, ...rest } = props;
    const { authToken, authUser } = useAuth();

    useEffect( () => {
        urlRewriteUtil(location, history);
    }, [] )

    return (
        <Route
            {...rest}
            render={matchProps => (
                authToken && authUser && (!no_redirect) ? (
                    <Redirect
                        to={{ pathname: "/home" }}
                    />
                ) : (
                    <Layout>
                        <Component {...matchProps} />
                    </Layout>
                )
            )}
        />
    );

};

export default PreAuthRouteWithLayout;
